import { isEmpty, isEqual, isNil } from 'lodash';
import { SDLUtil, RequestUtil } from '@/utils';

/* uri */
const encodeQueryString = data => {
  if (isEmpty(data)) {
    return '';
  }

  const ret = [];

  for (const [key] of Object.entries(data)) {
    ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
  }

  return ret.join('&');
}

const decodeQueryString = url => {
  return Object.fromEntries(new URLSearchParams(url));
}

const composeQueryString = data => {
  if (isEmpty(data)) {
    return '';
  }

  const ret = [];

  for (const [key] of Object.entries(data)) {
    ret.push(`${key}=${data[key]}`);
  }

  return ret.join('&');
}

/* http request */
const requestSuccess = data => !isNil(data) && (isEqual(data.message, 'SUCCESS') || isEqual(data.message, 'Success') || isEmpty(data.message))

const requestGet = (url, params) => {
  return RequestUtil.get(`${SDLUtil.API_URL}${url}?${encodeQueryString(params)}`)
  .then(({ data }) => {
    if (requestSuccess(data)) {
      return data;
    }
  })
  .catch(e => {
  });
}

const requestPost = (url, body) => {
  return RequestUtil.post(`${SDLUtil.API_URL}${url}`, body)
  .then(({ data }) => {
    if (requestSuccess(data)) {
      return data;
    }
  })
  .catch(e => {
  });
}

const removeFirstChar = (text, ch) => {
  if (!isEmpty(text)) {
    if (!isEmpty(ch)) {
      return isEqual(text[0], ch[0]) ? text.slice(1) : text;
    } else {
      return text.slice(1);
    }
  } else {
    return '';
  }
}

export {
  // uri
  encodeQueryString,
  decodeQueryString,
  composeQueryString,

  // http request
  requestGet,
  requestPost,

  // utilities
  removeFirstChar,
}



// WEBPACK FOOTER //
// ./src/service/coa/cspUtil.js